import React from 'react';
import { WidgetEmpty, Pill, useGoTo } from './common';

// A 14 day strip of real dates: invoice and cashflow due dates, todo due
// dates, contract period ends and KYC yearly reviews. Grouped by day.
const DeadlinesWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  if (items.length === 0) return <WidgetEmpty>Nothing is due in the next 14 days.</WidgetEmpty>;

  const groups = [];
  items.forEach((item) => {
    const last = groups[groups.length - 1];
    if (last && last.date === item.date) last.items.push(item);
    else groups.push({ date: item.date, label: item.date_label, days_left: item.days_left, items: [item] });
  });

  return (
    <div className="mydesk-deadlines">
      {groups.map((g) => (
        <div key={g.date} className={`mydesk-deadline-day ${g.days_left < 0 ? 'is-overdue' : g.days_left === 0 ? 'is-today' : ''}`}>
          <div className="mydesk-deadline-date">
            <span className="mydesk-deadline-label">{g.label}</span>
            <span className="mydesk-deadline-rel">
              {g.days_left < 0 ? `${Math.abs(g.days_left)} d overdue` : g.days_left === 0 ? 'Today' : g.days_left === 1 ? 'Tomorrow' : `in ${g.days_left} d`}
            </span>
          </div>
          <div className="mydesk-deadline-items">
            {g.items.map((item) => (
              <button
                key={item.key}
                type="button"
                className="mydesk-deadline-item"
                onClick={() => goTo(item.url)}
                disabled={!item.url}
              >
                <span className="mydesk-deadline-title">{item.title}</span>
                <span className="mydesk-deadline-sub">{item.subtitle}</span>
                <Pill tone={item.tone || 'neutral'}>{item.kind_label}</Pill>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DeadlinesWidget;
